import { render, staticRenderFns } from "./SessionListContainer.vue?vue&type=template&id=639d5fc8&scoped=true&"
import script from "./SessionListContainer.vue?vue&type=script&lang=js&"
export * from "./SessionListContainer.vue?vue&type=script&lang=js&"
import style0 from "./SessionListContainer.vue?vue&type=style&index=0&id=639d5fc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d5fc8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
